import React from 'react';

const STATUS_OPTIONS = [
  { label: 'All', value: 'all', color: 'bg-muted text-foreground' },
  { label: 'Draft', value: 'Draft', color: 'bg-slate-500/15 text-slate-600' },
  { label: 'Submitted', value: 'Submitted', color: 'bg-blue-500/15 text-blue-600' },
  { label: 'Accepted', value: 'Accepted', color: 'bg-emerald-500/15 text-emerald-600' },
  { label: 'Rejected', value: 'Rejected', color: 'bg-red-500/15 text-red-600' },
];

const BidStatusChips = ({ activeStatus, onChange }) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      {STATUS_OPTIONS?.map(opt => (
        <button
          key={opt?.value}
          onClick={() => onChange(opt?.value)}
          className={`flex-shrink-0 px-4 py-2 rounded-full text-xs font-semibold min-h-[36px] transition-all ${
            activeStatus === opt?.value
              ? `${opt?.color} ring-2 ring-current ring-offset-1 ring-offset-background`
              : 'bg-muted/60 text-muted-foreground'
          }`}
        >
          {opt?.label}
        </button>
      ))}
    </div>
  );
};

export default BidStatusChips;
